// TanStack Query hooks for data fetching

import { useQuery } from '@tanstack/react-query'

import {
  mockDrivers,
  mockTachographData,
  mockTasks,
  mockVehicles,
} from '../lib/mock-data'

// Simulate API delay
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

// Vehicles
export function useVehicles() {
  return useQuery({
    queryKey: ['vehicles-mock'],
    queryFn: async () => {
      await delay(500)
      return mockVehicles
    },
  })
}

export function useVehicle(id: string) {
  return useQuery({
    queryKey: ['vehicles-mock', id],
    queryFn: async () => {
      await delay(300)
      return mockVehicles.find((v) => v.id === id)
    },
  })
}

// Drivers
export function useDrivers() {
  return useQuery({
    queryKey: ['drivers-mock'],
    queryFn: async () => {
      await delay(500)
      return mockDrivers
    },
  })
}

export function useDriver(id: string) {
  return useQuery({
    queryKey: ['drivers-mock', id],
    queryFn: async () => {
      await delay(300)
      return mockDrivers.find((d: any) => d.id === Number(id))
    },
  })
}

// Tasks
export function useTasks() {
  return useQuery({
    queryKey: ['tasks-mock'],
    queryFn: async () => {
      await delay(500)
      return mockTasks
    },
  })
}

// Tachograph
export function useTachographData(driverId?: number) {
  return useQuery({
    queryKey: ['tachograph-mock', driverId],
    queryFn: async () => {
      await delay(500)
      if (driverId) {
        return mockTachographData.filter(
          (entry) => entry.driverId === driverId.toString(),
        )
      }
      return mockTachographData
    },
  })
}
